var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconStyle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 81,
    viewBox: "0 0 79 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xEB\xA0\x88\xEC\x9D\xB4\xEC\x96\xB4_1",
    clipPath: "url(#clip0_487_930)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M77.4109 1H12.7109V78.45H77.4109V1Z",
    fill: "#E7E1D0",
    stroke: "#231916",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M38.9716 13.46H52.3616C59.7416 13.46 65.7316 19.45 65.7316 26.83V64.04H25.6016V26.83C25.6016 19.45 31.5916 13.46 38.9716 13.46Z",
    fill: "black",
    stroke: "#231916",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M65.7316 61.69H25.6016V78.5H65.7316V61.69Z",
    fill: "#21AFD3",
    stroke: "#231916",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M45.9316 19.42H43.8916C37.7916 19.42 32.8516 24.36 32.8516 30.46V43.51C32.8516 48.79 37.1316 53.07 42.4116 53.07H43.5316V62.68C43.5316 62.68 39.8516 65.07 39.8516 70.96H50.1616C50.1616 70.96 52.0016 62.68 55.6816 62.68L56.9716 61.7V30.46C56.9716 24.36 52.0316 19.42 45.9316 19.42Z",
    fill: "#F5A94F",
    stroke: "#231916",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.9543 48.6886L13.7969 48.1102L11.7843 59.0974L14.9418 59.6758L16.9543 48.6886Z",
    fill: "#FFFDF5",
    stroke: "#231916",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.54109 56.9516L17.8036 58.4651L14.4974 76.5148C14.1533 78.3935 12.3475 79.6487 10.459 79.3028L9.01303 79.0379C7.13428 78.6938 5.87909 76.8881 6.22502 74.9995L9.53125 56.9498L9.54109 56.9516Z",
    fill: "#BF7B19",
    stroke: "#231916",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M18.46 52.5C28.1029 52.5 35.92 44.6829 35.92 35.04C35.92 25.3971 28.1029 17.58 18.46 17.58C8.81711 17.58 1 25.3971 1 35.04C1 44.6829 8.81711 52.5 18.46 52.5Z",
    fill: "#E7E1D0",
    stroke: "#231916",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M18.5111 46.44C24.8016 46.44 29.9011 41.3405 29.9011 35.05C29.9011 28.7595 24.8016 23.66 18.5111 23.66C12.2206 23.66 7.12109 28.7595 7.12109 35.05C7.12109 41.3405 12.2206 46.44 18.5111 46.44Z",
    fill: "#C4D2EC",
    stroke: "#231916",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M65.7383 51.25H77.4083",
    stroke: "#231916",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_487_930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.41,
    height: 80.36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStyle);
export default __webpack_public_path__ + "static/media/icon-style.51508916016ee594674533fae641a0a7.svg";
export { ForwardRef as ReactComponent };